import Image from 'next/image';
import Link from 'next/link';
import router from 'next/router';

import { cn, humanShorten } from '@app/libs/utils';

import { Properties } from './Properties';
import { Thumbnail } from './Thumbnail';

interface PropertiesSectionProps {
  className?: string;
  properties: any[];
}

export const PropertiesSection: React.FC<PropertiesSectionProps> = ({ className, properties }) => {
  return (
    <section className={cn('w-full flex flex-col items-center gap-10', className)}>
      <div className="flex flex-col items-center gap-3">
        <span className="text-sm font-semibold tracking-wide uppercase text-gray-500">
          Danh sách
        </span>
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Bất động sản mới nhất</h2>
      </div>

      <Properties properties={properties} mode="grid" />

      <Link
        href="/properties"
        className="inline-flex items-center justify-center gap-2.5 px-5 py-3 rounded-lg bg-blue-800 text-white font-bold text-sm hover:bg-blue-900 transition-all"
      >
        Xem thêm
      </Link>
    </section>
  );
};

export default PropertiesSection;
